import { CKButtonBar } from 'clearkit';

const timePeriods = {
  7: 'Last 7 days',
  14: 'Last 14 days',
  30: 'Last 30 days',
  60: 'Last 60 days',
};

type TimePeriodBarProps = {
  timePeriod: string;
  setTimePeriod: (timePeriod: string) => void;
  isLoading?: boolean;
};

const TimePeriodBar = ({
  timePeriod,
  setTimePeriod,
  isLoading = false,
}: TimePeriodBarProps) => {
  return (
    <CKButtonBar>
      {Object.entries(timePeriods).map(([key, value]) => (
        <CKButtonBar.Button
          isDisabled={isLoading}
          isSelected={key === timePeriod}
          key={key}
          onClick={() => setTimePeriod(key)}
        >
          {value}
        </CKButtonBar.Button>
      ))}
    </CKButtonBar>
  );
};

export { TimePeriodBar };
